import { render, staticRenderFns } from "./PolicySummary.vue?vue&type=template&id=03413f78&scoped=true&"
import script from "./PolicySummary.vue?vue&type=script&lang=js&"
export * from "./PolicySummary.vue?vue&type=script&lang=js&"
import style0 from "./PolicySummary.vue?vue&type=style&index=0&id=03413f78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03413f78",
  null
  
)

export default component.exports